import { useState, useEffect } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { useNavigate, useLocation } from "react-router-dom";

const Users = () => {
    const [users, setUsers] = useState([]);
    const axiosPrivate = useAxiosPrivate();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        let isMounted = true;

        const controller = new AbortController();

        const getUsers = async () => {

            try {
                const response = await axiosPrivate.get('/users', {
                    signal: controller.signal
                });
                console.log(response.data);
                isMounted && setUsers(response.data);
            } catch (err) {
                if (isMounted) {
                    console.error(err);
                    if (err.response?.status === 403) {
                        navigate('/login', { state: { from: location }, replace: true });
                    }
                }
            }
        }

        getUsers();

        return () => {
            isMounted = false;
            controller.abort();
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div>
            <h2>Users</h2>
            {users?.length
                ? (
                    <table className="standard">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Verified</th>
                            </tr>
                        </thead>
                        <tbody>
                            {users.map((user, i) => {
                                return (
                                    <tr key={i}>
                                        <td>{user?.name}</td>
                                        <td>{user?.email}</td>
                                        <td>{user?.verified ? "Yes" : "No"}</td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                ) : <p>No users to display</p>
            }
        </div>
    );

};

export default Users;